var _linearGradient, _path, _linearGradient2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8VsCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "HjBUFHyNtcsDcBgnZBZ2Sa",
    x1: 37.8,
    x2: 37.8,
    y1: 43.37,
    y2: 7.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29b6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13b2f6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HjBUFHyNtcsDcBgnZBZ2Sa)",
    d: "M34.176,4.249c0.188,0.092,5.688,2.716,8.374,3.998C43.437,8.67,44,9.564,44,10.546v26.86 c0,0.981-0.559,1.874-1.443,2.299c-2.548,1.228-7.611,3.666-7.948,3.826C34.361,43.649,33.709,44,33.181,44 c-0.678,0-1.133-0.316-1.58-0.73L34,35.711V5.715l-2.254-1.135C32.228,4.109,32.896,4,33.291,4C33.653,4,33.948,4.138,34.176,4.249z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "HjBUFHyNtcsDcBgnZBZ2Sb",
    x1: 6.085,
    x2: 34.793,
    y1: 34.801,
    y2: 7.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#0076bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#0069b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0069b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#0069b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#0072b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#0076bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#0076bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006eb9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#HjBUFHyNtcsDcBgnZBZ2Sb)",
    d: "M9,33.896l25-19.023V5.83c0-1.299-1.662-1.808-2.337-1.184 C31.008,5.25,4.658,29.239,4.658,29.239c-0.9,0.83-0.849,2.267,0.107,3.032c0,0,1.324,1.232,1.803,1.574 C7.304,34.37,8.271,34.43,9,33.896z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0288d1",
    d: "M9,14.104l25,19.054v8.771c0,1.198-1.42,2.193-2.399,1.341L4.658,18.761 c-0.9-0.83-0.849-2.267,0.107-3.032c0,0,1.324-1.232,1.803-1.574C7.304,13.63,8.271,13.57,9,14.104z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8VsCode);
export default __webpack_public_path__ + "static/media/icons8-vs-code.955c351a6079b47cf50c54bf2d30c75e.svg";
export { ForwardRef as ReactComponent };